<template>
<el-dialog :title=" '查看'" :close-on-click-modal="false" width="90%" :visible.sync="viewData.visible">
    <el-tabs>
        <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" size="small" class="org-dialog-form">
            <div class="des_box">
                <el-descriptions class="margin-top" :column="3" size="small" border style="margin-bottom: 15px;">
                    <el-descriptions-item label="工厂:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="werks" style="margin-bottom: 0;">
                            <span>{{dataForm.werks}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="供应商代码:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="lifnr" style="margin-bottom: 0;">
                            <span>{{dataForm.lifnr}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="结算起始日期:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="zbadutl" style="margin-bottom: 0">
                            <span>{{dateFormat1(dataForm.zbadutl)}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="工厂名称:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="name2" style="margin-bottom: 0;">
                            <span>{{dataForm.name2}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="供应商名称:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="name1" style="margin-bottom: 0;">
                            <span>{{dataForm.name1}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="结算终止日期:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="zbaduth" style="margin-bottom: 0">
                           <span>{{dateFormat1(dataForm.zbaduth)}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="结算单号:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="zjsdh" style="margin-bottom: 0;">
                            <span>{{dataForm.zjsdh}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="未税总金额:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="zbhszje" style="margin-bottom: 0;">
                            <span>{{towNumber(dataForm.zbhszje)}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="发布日期时间:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="zpub" style="margin-bottom: 0">
                            <span>{{datTimeFormat(dataForm.zpub)}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="结算单类型:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="ztype" style="margin-bottom: 0;">
                            <span>{{accountTypeFormat(dataForm.ztype)}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="含税总金额:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="zhszje" style="margin-bottom: 0;">
                            <span>{{towNumber(dataForm.zhszje)}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="开票通知日期:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="zkptzrq" style="margin-bottom: 0">
                            <span>{{dateFormat1(dataForm.zkptzrq)}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
        </el-form>
        <el-table :data="accountPartList" row-key="id" size="small" border style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}">
            <el-table-column type="index" width="50" label="序号">
                <template slot-scope="scope">
                    {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                </template>
            </el-table-column>
            <el-table-column prop="zhtbh" header-align="center" align="center" label="合同编码" width="120">
            </el-table-column>
            <el-table-column prop="ebeln" header-align="center" align="center" label="采购订单号">
            </el-table-column>
            <el-table-column prop="matnr" header-align="center" align="center" label="物料编码">
            </el-table-column>
            <el-table-column prop="txz01" header-align="center" align="center" label="物料描述">
            </el-table-column>
            <el-table-column prop="ekorg" header-align="center" align="center" label="采购组织">
            </el-table-column>
            <el-table-column prop="ekgrp" header-align="center" align="center" label="采购组">
            </el-table-column>
            <el-table-column prop="eknam" header-align="center" align="center" label="采购组名称">
            </el-table-column>
            <el-table-column prop="zkpdw" header-align="center" align="center" label="开票单位">
                <template slot-scope="scope">
                    <span>{{getUnitName(scope.row.zkpdw)}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="zkpsl" header-align="center" align="center" label="开票数量">
            </el-table-column>
            <!-- <el-table-column prop="zkpsl" header-align="center" align="center" label="开票数量">
            </el-table-column>
            <el-table-column prop="logrt" header-align="center" align="center" label="库存地点">
            </el-table-column>
            <el-table-column prop="lgobe" header-align="center" align="center" label="库存地点名称">
            </el-table-column> -->
            <el-table-column prop="znetpr" header-align="center" align="center" label="单价">
            </el-table-column>
            <el-table-column prop="kpein" header-align="center" align="center" label="条件定价单位">
            </el-table-column>
            <el-table-column prop="wrbtr" header-align="center" align="center" label="不含税金额">
                <template slot-scope="scope">
                    <span>{{towNumber(scope.row.wrbtr)}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="mwskz" header-align="center" align="center" label="税码">
                <template slot-scope="scope">
                    <span>{{getTaxCodeName(scope.row.mwskz)}}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" class="mb15">
        </el-pagination>
    </el-tabs>
</el-dialog>
</template>

<script>
import {
    edit,
    add,
    listPart,
    deletePartBatch,
    queryById,
} from '@/controller/settlement'
import {
    getLabelByValue,
    ACCOUNT_TYPE_VALUE,
} from '@/utils/const'
import {
    getFactoryList,
    getUnitList,
    getTaxCodeList
} from '@/controller/systemData'
import moment from 'moment'
export default {
    data() {
        return {
            viewData: {
                visible: false,
                width: ''
            },
            viewFlag: '',
            dataList: [],
            getLabelByValue: getLabelByValue,
            ACCOUNT_TYPE_VALUE: ACCOUNT_TYPE_VALUE,
            accountPartList: [],
            factoryList: [],
            unitList: [],
            taxCodeList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataForm: {
                id: 0,
                lifnr: '',
                name1: '',
                zjsdh: '',
                zkptzrq: '',
                zhszje: '',
                zbhszje: '',
                werks: '',
                name2: '',
                ztype: '',
                zpub: '',
                payDate: ''
            },
        }
    },
    components: {
    },
    mounted() {},
    filters: {
        rounding (value) {
            return value.toFixed(2)
        }
    },
    methods: {
        towNumber(val) {      
            return Number(val).toFixed(2)    
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.listPart();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.listPart();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        // 删除零件
        deleteHandleAccountPart(id) {
            let ids = id ? [id] :
                this.dataListSelections.map((item) => {
                    return item.id;
                });
            this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    deletePartBatch(ids)
                        .then((data) => {
                            if (data && data.code === "00") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.listPart();
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {});
        },
        init(data, id, viewFlag) {
            this.dataForm.id = id || 0
            this.accountPartList = [];
            this.viewData.visible = true
            this.viewFlag = viewFlag;
            this.$nextTick(() => {
                // this.$refs['dataForm'].resetFields()
                // this.dataForm.tenantName = sessionStorage.getItem('tenantName')
                if (this.dataForm && this.dataForm.id) {
                    queryById({}, this.dataForm.id).then(data => {
                        if (data && data.code === '00') {
                            this.dataForm = data.body
                        }
                        this.listPart();
                    });
                }
                this.getFactoryList()
                this.getUnitList()
                this.getTaxCodeList()
            })
        },
        //获取工厂数据
        getFactoryList() {
            getFactoryList({
                post: "",
                address: "",
                factoryDesc: "",
                factoryCode: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            })
        },
        getUnitList() {
            getUnitList({
                code: "",
                name: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            });
        },
        getTaxCodeList() {
            getTaxCodeList({
                taxCode: "",
                taxRate: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.taxCodeList = data.body;
                }
            });
        },
        getUnitName(code) {
            const unit = this.unitList.find(unit => unit.code === code)
            return unit ? unit.name : ''
        },

        // 查所有订单零件表
        listPart() {
            listPart({
                zjsdh: this.dataForm.zjsdh,
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.accountPartList = data.body.records;
                    this.totalPage = data.body.total;
                } else {
                    this.accountPartList = [];
                    this.totalPage = 0;
                }
            });
        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                let params = this.dataForm
                if (valid) {
                    // debugger
                    if (this.dataForm.id) {
                        edit(params).then(data => {
                            if (data && data.code === '00') {
                                // this.dataForm = data.body;
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        add(params).then(data => {
                            if (data && data.code === '00') {
                                this.dataForm.id = data.body ? data.body.id : '';
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.$emit('refreshDataList')
                                    }
                                })

                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
        accountTypeFormat: function (value) {
            if (!value) {
                return ''
            }
            return getLabelByValue(ACCOUNT_TYPE_VALUE, value)
        },
        setFactoryName(val) {
            const factory = this.factoryList.find(factory => factory.factoryCode === val)
            this.dataForm.name2 = factory ? factory.factoryDesc : ''
        },
        dateFormat1(date) {
            return moment(date).format("YYYY-MM-DD")
        },
        datTimeFormat(date) {
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        // 获取税码的名字
        getTaxCodeName(code) {
            const taxCode = this.taxCodeList.find(taxCode => taxCode.taxCode === code)
            return taxCode ? taxCode.taxRate : ''
        },
        getStyle() {
            return 'width: 120px; text-align: right'
        },
        getStyle2() {
            return 'width: 392px;'
        }
    }
}
</script>
